/* ============
 * Campaign Type Transformer
 * ============
 *
 * The transformer for the campaignTypes.
 */

import Transformer from './transformer';

export default class campaignTypeTransformer extends Transformer {

  static fetch(campaignTypes) {
    return {
      id: campaignTypes.id,
      name: campaignTypes.name,
    };
  }

  static send(campaignTypes) {
    return {
      id: campaignTypes.id,
      name: campaignTypes.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/campaignType.js